/**
 * Lazy-loaded Pokémon dex.
 *
 * @pkmn/data + @pkmn/dex together include the full learnsets table — ~5 MB
 * uncompressed, ~700 KB gzipped. That breaks the 3 MB initial-bundle gate
 * (Phase 0b spike d) when imported at module top-level. The same Phase 0b
 * fallback ladder that pinned @pkmn/sim as a dynamic import on first battle
 * applies here: defer until first use, cache the result.
 *
 * Phase 7 calls this just to prove the lazy chunk loads correctly. Phase 8a
 * (battle scene) will be the first real consumer.
 */
import type { Generation } from '@pkmn/data';

let cached: Promise<Generation> | undefined;

export function loadGen3(): Promise<Generation> {
  if (!cached) {
    cached = (async () => {
      const [{ Generations }, { Dex }] = await Promise.all([
        import('@pkmn/data'),
        import('@pkmn/dex'),
      ]);
      return new Generations(Dex).get(3);
    })();
  }
  return cached;
}
